
import { Select, SelectContent, SelectItem } from "@dextech-ai/dex-design-system";
import { SELECT_ALL_VALUE } from "@/utils/select-items";
import PropTypes from 'prop-types';

export const MultiSelectEditCell = ({
	value,
	options,
	optionKey = 'value',
	optionValue = 'value',
	optionSelected = 'value',
	onChange,
}) => {
	const originalValue = (Array.isArray(value) ? value : value?.split(',')?.map(s => s.trim()))?.filter(Boolean)

	const handleMultiSelectOnChange = (values) => {
		if (values.includes(SELECT_ALL_VALUE)) {
			onChange({
				target: {
					value: originalValue?.length === options.length ? [] : options.map(option => option?.[optionSelected])
				}
			});
			return;
		}
		onChange({ target: { value: values } });
	}

	return (
		<div className="data-table3__edit-select">
			<Select
				multiple
				data-testid="data-table3-edit-multi-select"
				aria-label="data-table3-edit-multi-select"
				placeholder="Select Option"
				maxTagCount="responsive"
				value={originalValue ?? []}
				onChange={handleMultiSelectOnChange}
			>
				<SelectContent>
					<SelectItem key={SELECT_ALL_VALUE} value={SELECT_ALL_VALUE}>All Option</SelectItem>
					{options.map(option => (
						<SelectItem key={option?.[optionKey]} value={option?.[optionSelected]}>{option?.[optionValue]}</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	)
};

MultiSelectEditCell.propTypes = {
	value: PropTypes.any,
	options: PropTypes.array,
	optionKey: PropTypes.string,
	optionValue: PropTypes.string,
	optionSelected: PropTypes.string,
	onChange: PropTypes.func,
};

export const SingleSelectEditCell = ({
	value,
	options,
	optionKey = 'value',
	optionValue = 'value',
	optionSelected = 'value',
	onChange,
}) => {
	const selectedValue = value?.toUpperCase();
	const hasSelectedOption = options.some(option => option?.[optionSelected]?.toUpperCase() === selectedValue);

	return (
		<div className="data-table3__edit-select data-table3__edit-select--single">
			<Select
				data-testid="data-table3-edit-single-select"
				aria-label="data-table3-edit-single-select"
				placeholder="Select Option"
				value={hasSelectedOption ? selectedValue : null}
				onChange={(selected) => onChange({ target: { value: selected } })}
			>
				<SelectContent>
					{options.map(option => (
						<SelectItem key={option?.[optionKey]} value={option?.[optionSelected]?.toUpperCase()}>{option?.[optionValue]}</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	)
};

SingleSelectEditCell.propTypes = {
	value: PropTypes.any,
	options: PropTypes.array,
	optionKey: PropTypes.string,
	optionValue: PropTypes.string,
	optionSelected: PropTypes.string,
	onChange: PropTypes.func,
};

export const PageSizeSelect = ({
	value,
	options,
	onChange,
}) => {
	return (
		<span className="data-table__table__pagination__page-size">
			<Select
				data-testid="pagination-pagesize"
				size="sm"
				value={value}
				onChange={onChange}
			>
				<SelectContent>
					{options.map(pageSize => (
						<SelectItem key={pageSize} value={pageSize}>{pageSize}</SelectItem>
					))}
				</SelectContent>
			</Select>
		</span>
	)
};

PageSizeSelect.propTypes = {
	value: PropTypes.number,
	options: PropTypes.arrayOf(PropTypes.number),
	onChange: PropTypes.func,
};
